module.exports = "/images/avatar.png?f8520f58c63da43c1449f587f06cfee7";